import React from 'react';
import styled from '@emotion/styled';
import { assetUrl } from '~/helpers';

interface StyledWrapperProps {
  image: string;
  mode: 'cover' | 'contain';
}

const StyledWrapper = styled.div<StyledWrapperProps>`
  background-image: url(${(props) => props.image});
  background-size: ${(props) => props.mode};
`;

interface VideoPlayerPreviewProps {
  playerImage: string;
  mode?: 'contain' | 'cover';
}

const VideoPlayerPreview = ({
  playerImage,
  mode = 'contain',
}: VideoPlayerPreviewProps) => {
  return (
    <StyledWrapper
      className='w-full h-full relative bg-neutral-600 bg-center bg-no-repeat flex items-center justify-center'
      image={playerImage}
      mode={mode}
    >
      <img
        className='absolute bottom-0 left-0 px-5 py-2.5'
        src={assetUrl(
          'assets/images/message-template/player-controls-full.svg'
        )}
      />
    </StyledWrapper>
  );
};

export default VideoPlayerPreview;
